import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
const API_BASE = 'sfdc/v1/';
const portalId = PortalIdParser.get();
export function getCampaigns() {
  return http.get(`${API_BASE}campaigns/${portalId}`, {
    query: {
      detailView: false
    }
  });
}
export function getSfdcSettings() {
  return http.get(`${API_BASE}settings/`);
}